export const seoHost = "https://www.greystar.com";

export const urlFormat = (input: string, encode: boolean): string => {
  const url = input
    .toLowerCase()
    .replaceAll(",", "")
    .replaceAll(" ", "-")
    .replaceAll("/", "-")
    .trim();

  return encode ? encodeURIComponent(url) : url;
};

export const normaliseUrl = (url: string): string => {
  return url.replace(seoHost, "");
};
